import { useNavigate } from 'react-router-dom';
import { BiLogOut } from 'react-icons/bi';
import { ReactNode } from 'react';
import logo from '../../assets/logo.png';
import Typography from '../../components/Typography';
import Section from '../../components/Section';
import Card from '../../components/Card';
import styles from './DashboardLayout.module.scss';
import IconButton from '../../components/IconButton';
import { useUserSession } from '../../components/UserSession';

export interface DashboardLayoutProps {
  children: ReactNode;
  header?: ReactNode;
  nav?: ReactNode;
  footer?: ReactNode;
}

function DashboardLayout({
  children,
  header,
  nav,
  footer,
}: DashboardLayoutProps) {
  const { user, setToken, isAuthenticating } = useUserSession();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Section className={styles.nav}>
        <img src={logo} alt="Inform logo" className={styles.logo} />
        <div className={styles.actions}>
          <Card
            className={styles.name}
            padding="0.25rem"
            backgroundColor="background-2"
          >
            <Typography
              className={styles.icon}
              textType="p1"
              as="div"
              textWeight="bold"
              textColor="background-1"
            >
              {isAuthenticating ? '?' : user?.firstName?.charAt(0)}
            </Typography>
            <Typography textType="p3" as="span" textWeight="bold">
              {isAuthenticating
                ? 'Unknown User'
                : `${user?.firstName} ${user?.lastName}`}
            </Typography>
          </Card>
          <IconButton
            onClick={() => {
              setToken(null);
              navigate('/');
            }}
            icon={BiLogOut}
            variant="ghost"
            buttonColor="error"
            aria-label="Logout"
          />
        </div>
      </Section>
      <Section className={styles.body}>
        <div className={styles.sidenav}>
          {header && (
            <Card
              className={styles.header}
              padding="1.25rem"
              backgroundColor="background-1"
            >
              {header}
            </Card>
          )}
          {nav && (
            <Card padding="1.25rem" backgroundColor="background-2">
              {nav}
            </Card>
          )}
          {footer && <Card padding="0">{footer}</Card>}
        </div>
        <Card className={styles.content} backgroundColor="background-2">
          {children}
        </Card>
      </Section>
    </div>
  );
}

export default DashboardLayout;
